module.exports = __webpack_public_path__ + "img/details-starts.png?0830e7cb25ed4849da8e4608004bd63f";